module.exports = __webpack_public_path__ + "./docs/img/java.2ce207fe2cf5a54a2a7ebe481e28ff1e.svg";